export default "__VITE_ASSET__4c16b516__"